import { Factory } from "@/data/dao/Factory";
import { PlanningDao } from "@/data/dao/service/PlanningDao";
import type { IOrderApplication, IOrderApplicationDetails } from "@/data/model/OrderApplication";
import { Format } from "@/data/util/Format";



import { i18n } from "@/portal/Trans";
import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { OrderApplicationForm } from "@/portal/forms/OrderApplicationForm";
import { TastierGlobal } from "@/portal/globalAccess";
import { UiNotification } from "@/portal/ui/Notification";


export class OrderApplicationController extends BaseTabbedController<IOrderApplicationDetails> {
    private readonly orderApplicationForm: OrderApplicationForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<PlanningDao>(PlanningDao).useCaseDataSource as any);

        this.orderApplicationForm = new OrderApplicationForm(this.formContentByTabName("orderapplicationedit"));
        this.registerModelForm(this.orderApplicationForm);
    }

    protected onModelLoaded(m?: IOrderApplicationDetails) {
        if (this.copyEntityId != null) {
            UiNotification.showSuccess(i18n("useCase.orderApplicationCopiedAndEditingNow"));
        }

        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.orderApplicationForm.setData(m, this.copyEntityId);
    }
}
